import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserInfo, UserService } from "../../../shared";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { Top5DialogComponent } from "../top5-dialog/top5-dialog.component";

@Component({
	selector: "app-login-page-sso",
	templateUrl: "./login-page-sso.component.html",
	styleUrls: ["./login-page-sso.component.css"],
})
export class LoginPageSSOComponent implements OnInit {
	constructor(private activatedRoute: ActivatedRoute, private userService: UserService, private router: Router, private dialogService: DialogService) {}

	ngOnInit(): void {
		var SSOB64: string = this.activatedRoute.snapshot.params["SSOData"];
		SSOB64 = this.TranslateToB64(SSOB64);

		var SSOString = atob(SSOB64);
		this.SSOData = JSON.parse(SSOString);

		console.log("SSO Data");
		console.log(this.SSOData);

		this.FinishLogin();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	SSOData: any;

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	FinishLogin() {
		//
		// Set User/Access Token
		//
		var user = new UserInfo();
		user.c_date = moment(new Date()).format("MM/DD/YYYY");
		user.isLoggedIn = true;
		user.token = this.SSOData.AccessToken;
		user.refresh_token = this.SSOData.RefreshToken;
		user.token_expiration = this.SSOData.Expiration;
		user.userID = this.SSOData.UserID;
		user.personID = this.SSOData.PersonID;
		user.userName = this.SSOData.Username;
		user.UserLevelID = this.SSOData.UserLevelID;
		user.SSOLogoutLink = this.SSOData.SSOLogoutLink;
		this.userService.setCurrentUser(user);

		//
		// Navigate to User's default page
		//
		var DefaultPage = this.SSOData.DefaultPageRoute;

		DefaultPage = String(DefaultPage).toLowerCase();

		//
		// Homepage automatically opens Top 5 Popup
		// If not homepage/normal dashboard open top 5
		//
		if (DefaultPage != "/") {
			//
			// Open Top 5
			//
			var ref = this.dialogService.open(Top5DialogComponent, {
				header: "Items Needing Administrator's Attention",
				width: "fit-content",
				data: {},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
				}
			});
		}

		this.router.navigate([DefaultPage]);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	TranslateToB64(input: string): string {
		let ans: string = input;

		ans = this.ReplaceAllOccur(ans, "$", "+");
		ans = this.ReplaceAllOccur(ans, "_", "/");
		ans = this.ReplaceAllOccur(ans, "-", "=");
		ans = this.ReplaceAllOccur(ans, "~", ";");

		return ans;
	}

	//////////////////////////////////////////////////////////
}
